// src/pages/admin/ClientDetails.js
import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useParams, Link } from "react-router-dom";

export default function ClientDetails() {
  const { id } = useParams(); // this is the clientId
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadClient = async () => {
      const ref = doc(db, "clients", id);
      const snap = await getDoc(ref);

      if (snap.exists()) {
        setClient({ id: snap.id, ...snap.data() });
      }
      setLoading(false);
    };

    loadClient();
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen text-gray-500">
        Loading client details…
      </div>
    );
  }

  if (!client) {
    return (
      <div className="flex justify-center items-center h-screen text-red-500">
        Client not found.
      </div>
    );
  }

  const name = client.fullName || client.name || "Unnamed Client";

  const renderDaysOfWork = () => {
    if (Array.isArray(client.daysOfWork)) {
      return client.daysOfWork.join(", ");
    }
    if (client.daysOfWork) return client.daysOfWork;
    return "Not set";
  };

  return (
    <div className="p-6 max-w-xl mx-auto space-y-5">
      <h1 className="text-2xl font-bold text-gray-700 mb-2">{name}</h1>

      {/* Info card */}
      <div className="bg-white shadow-md rounded-2xl p-5 space-y-2 text-gray-700">
        <p>
          <strong>Address:</strong>{" "}
          {client.address && client.address.trim()
            ? client.address
            : "Not provided"}
        </p>
        <p>
          <strong>Postcode:</strong> {client.postcode || "Not provided"}
        </p>
        <p>
          <strong>Contact:</strong> {client.contact || "Not provided"}
        </p>
        <p>
          <strong>Care Notes:</strong> {client.notes || "None"}
        </p>
        <p>
          <strong>Rate (£/hr):</strong>{" "}
          {client.rate !== undefined ? client.rate : "Not set"}
        </p>
        <p>
          <strong>Total Hours (rota):</strong>{" "}
          {client.totalHours !== undefined ? client.totalHours : "Not set"}
        </p>
        <p>
          <strong>Days of Work:</strong> {renderDaysOfWork()}
        </p>
        {Array.isArray(client.timePeriods) && client.timePeriods.length > 0 && (
          <p>
            <strong>Time Periods:</strong> {client.timePeriods.join(", ")}
          </p>
        )}
      </div>

      {/* Buttons */}
      <div className="space-y-3">
        <Link to={`/admin/checklists/${client.id}`}>
          <button className="w-full p-3 bg-pink-500 text-white rounded-2xl shadow hover:bg-pink-600 transition">
            Edit Task List
          </button>
        </Link>

        <Link to={`/admin/clients/${client.id}/edit`}>
          <button className="w-full p-3 bg-gray-800 text-white rounded-2xl shadow hover:bg-gray-900 transition">
            Edit Client Details
          </button>
        </Link>

        <Link to="/admin/clients">
          <button className="w-full p-3 bg-gray-200 text-gray-700 rounded-2xl shadow hover:bg-gray-300 transition">
            Back to Clients
          </button>
        </Link>
      </div>
    </div>
  );
}
